import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Heading, Text, List, Button } from "@zillow/constellation";
const SuccessState = ({
  referenceNumber,
  onSubmitAnother
}) => {
  return /* @__PURE__ */ jsxs(Box, { sx: {
    margin: "0 auto",
    marginTop: "$spacing.xl",
    marginBottom: {
      default: "$spacing.xl",
      tablet: "$spacing.2xl"
    },
    padding: {
      default: "$spacing.lg",
      tablet: "$spacing.xl"
    },
    backgroundColor: "$colors.white",
    borderRadius: "$radii.lg",
    boxShadow: "$shadows.lg",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch"
  }, children: [
    /* @__PURE__ */ jsx(Heading, { as: "h2", fontType: "h4", textAlign: "center", marginBottom: "md", fontColor: "textDark", fontFamily: "sansSerif", children: "Report submitted successfully" }),
    /* @__PURE__ */ jsx(Text, { fontType: "body", textAlign: "center", marginBottom: "md", color: "$colors.textMedium", children: "Thank you for helping ensure all consumers have fair access to listings. Our team will review the information provided." }),
    /* @__PURE__ */ jsxs(Box, { sx: {
      backgroundColor: "$colors.gray100",
      borderRadius: "$radii.md",
      padding: "$spacing.md",
      marginBottom: "$spacing.md",
      textAlign: "center"
    }, children: [
      /* @__PURE__ */ jsx(Text, { as: "p", fontType: "body", fontColor: "textDark", children: "Your report reference number:" }),
      /* @__PURE__ */ jsx(Text, { fontColor: "brand", fontType: "bodyHeading", marginTop: "xs", children: referenceNumber })
    ] }),
    /* @__PURE__ */ jsxs(Box, { sx: {
      backgroundColor: "$colors.backgroundBlue",
      borderRadius: "$radii.md",
      padding: "$spacing.md",
      marginBottom: "$spacing.md"
    }, children: [
      /* @__PURE__ */ jsx(Heading, { as: "h3", fontType: "h6", marginBottom: "xs", fontColor: "textDark", fontFamily: "sansSerif", placement: "page", children: "What happens next?" }),
      /* @__PURE__ */ jsxs(List, { appearance: "bullet", children: [
        /* @__PURE__ */ jsx(List.Item, { children: "Our team will review your report and the documentation provided to us" }),
        /* @__PURE__ */ jsx(List.Item, { children: "We'll investigate whether the listing is being publicly marketed but not available on MLS, Zillow or other platforms" }),
        /* @__PURE__ */ jsx(List.Item, { children: "If the violation is confirmed, we'll take appropriate action according to our listing access standards" }),
        /* @__PURE__ */ jsx(List.Item, { children: "Together, we're ensuring all consumers have fair access to real estate information" })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Box, { sx: {
      display: "flex",
      justifyContent: "center"
    }, children: /* @__PURE__ */ jsx(Button, { buttonType: "primary", size: "lg", onClick: onSubmitAnother, children: "Submit another report" }) })
  ] });
};
export {
  SuccessState as default
};
